import { FranchiseService } from 'services/FranchiseService/FranchiseService';
import { MedicineService } from 'services/MedicineService/MedicineService';

import { Common } from 'utils';

import { medicineManagementEvent } from 'stores/MedicineManagement/MedicineManagementEvents';
import medicineManagementStore from 'stores/MedicineManagement/MedicineManagementStore';

const execute = async () => {
  try {
    medicineManagementEvent({ isLoading: true });
    const { pageNow, pageSize } = medicineManagementStore.getState();

    const [medicines, franchise] = await Promise.all([
      MedicineService.getMedicines(pageNow, pageSize),
      FranchiseService.getAll(),
    ]);

    await Common.sleep(1000);
    medicineManagementEvent({
      list: medicines,
      listFranchise: franchise?.data?.franchises || null,
    });
  } catch (err) {
    // console.log(err)
  } finally {
    medicineManagementEvent({ isLoading: false });
  }
};

export const getMedicineManagementUseCase = { execute };
